import React, {useEffect, useMemo, useState} from "react";
import { get, merge } from "lodash";
import ExtendedTextField from "../materialui/ExtendedTextField";

const FormikTextField = ({ formik, name, label, autoFocus, type, autoComplete, multiline, rows, InputProps, disabled, format, slotProps, onBlurOnly, size, placeholder, helperText: helperTextProp, onFocus }) => {
  const formikValue = get(formik.values, name);
  const [value, setValue] = useState(formikValue || '');
  const hasError = get(formik.touched, name) && Boolean(get(formik.errors, name));
  const formatFn = format || (value => value);

  useEffect(() => {
    setValue(formatFn(formikValue) ?? '');
  }, [formikValue]);

  const helperText = useMemo(() => {
    if (hasError) {
      return get(formik.errors, name);
    }
    return helperTextProp || '';
  }, [formik, name, hasError, helperTextProp]);

  return (
    <ExtendedTextField
      autoFocus={autoFocus}
      autoComplete={autoComplete || "off"}
      fullWidth
      id={name}
      label={label}
      name={name}
      multiline={multiline}
      placeholder={placeholder}
      rows={multiline ? rows || 2 : undefined}
      onChange={event => {
        const newValue = formatFn(event.target.value);
        setValue(event.target.value);
        if (!onBlurOnly) {
          formik.setFieldValue(name, newValue);
        }
      }}
      onFocus={onFocus}
      onBlur={(event) => {
        const newValue = formatFn(event.target.value);
        setValue(event.target.value);
        formik.setFieldValue(name, newValue);
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          const newValue = formatFn(event.target.value);
          setValue(event.target.value);
          formik.setFieldValue(name, newValue);
        }
      }}
      value={value}
      variant="outlined"
      error={hasError}
      helperText={helperText}
      disabled={disabled}
      slotProps={merge({
        inputLabel: {
          shrink: Boolean(placeholder) || (value !== '' && value != null),
        }
      }, slotProps)}
      InputProps={InputProps}
      size={size}
      type={type}
    />
  );
}

export default FormikTextField;